import { CalendarCellProps } from '@/components/calendar/Calendar';
import { merge } from '@/helpers/Utility';
import { isDateInPast } from '@/helpers/dateHelper';
import { FC } from 'react';
import { DeleteButton } from './DeleteButton';
import { IconToDisplay } from './IconToDisplay';
import { RosterCalendarContextObject } from './useRosterCalendarEvents';

export const RosterCalendarContent: FC<CalendarCellProps<RosterCalendarContextObject>> = ({ date, contextObject }) => {
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);

  const inPast = isDateInPast(date, currentDate);

  if (!contextObject) {
    return <div></div>
  }

  return (
    <div className={merge('relative h-full w-full', contextObject.hoverOnly ? 'opacity-0 hover:opacity-100' : '')}>
      <div className={`h-full flex items-center justify-center flex-row space-x-8 px-4`}>
        <IconToDisplay contextObject={contextObject} date={date} />
      </div>
      {!inPast && contextObject?.onDeleteClick && (
        <DeleteButton
          onClick={contextObject.onDeleteClick}
        />
      )}
    </div>
  );
};
